import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import T from 'prop-types';
import { values, flatten, isEmpty } from 'lodash-es';
import cx from 'classnames';

import {
  Menu,
  MenuButton,
  useMenuProps,
} from '../../../../DropdownSet';

import CrossAppPairingsSubMenu from './CrossAppPairingsSubMenu';

const CrossAppPairingsDropdown = ({
  report = {},
  unselectedStateText = 'Select App',
  groupAppsBy = 'sector',
  onChange,
}) => {
  const anchorRef = useRef();
  const menuProps = useMenuProps({
    menuStyle: { width: 361 },
    className: 'paired-apps-dropdown-menu',
  });

  const {
    data_points,
    cross_apps_pairs,
    panel_version,
    entities,
    excludedEntities,
    cross_apps_pairs_decorated,
  } = report;

  const options = entities
    .filter(entity => !excludedEntities.some(excluded => excluded.ref_no === entity.ref_no))
    .map(entity => ({
      ...entity,
      label: entity.name,
      value: entity.ref_no,
    }));

  const disabled = isEmpty(data_points?.filter(item => item.startsWith('cross_app')));

  const [isMenuOpen, setMenuOpen] = useState(false);
  const [currentRefNo, setCurrentRefNo] = useState('');

  const handleMenuClose = useCallback((e) => {
    setMenuOpen(e.reason !== 'blur');
  }, []);

  const selectedLabel = useMemo(() => {
    const valuesSelected = flatten(values(cross_apps_pairs)).length;
    return valuesSelected ? `${valuesSelected} Apps Selected` : null;
  }, [cross_apps_pairs]);

  const isCrossAppSelected = data_points?.some(item => item.startsWith('cross_app'));

  useEffect(() => {
    setCurrentRefNo('');
  }, [panel_version]);

  return (
    <Menu
      anchorRef={anchorRef}
      state={isMenuOpen ? 'open' : 'closed'}
      className="paired-apps-dropdown"
      menuButton={(
        <MenuButton
          ref={anchorRef}
          variant="light"
          className={cx("paired-apps-dropdown-button", { error: isCrossAppSelected && isEmpty(cross_apps_pairs) })}
          disabled={disabled || !options.length}
          onClick={() => setMenuOpen(true)}
        >
          {selectedLabel || unselectedStateText}
        </MenuButton>
      )}
      setDownOverflow
      {...menuProps}
      onClose={handleMenuClose}
    >
      {options.map((option) => (
        <CrossAppPairingsSubMenu
          key={option.value}
          selected={cross_apps_pairs}
          app={option}
          unselectedStateText={unselectedStateText}
          crossAppsPairsDecorated={cross_apps_pairs_decorated}
          groupAppsBy={groupAppsBy}
          panelVersion={panel_version}
          currentRefNo={currentRefNo}
          onCurrentRefNoChange={setCurrentRefNo}
          onChange={onChange}
        />
      ))}
    </Menu>
  );
};

CrossAppPairingsDropdown.propTypes = {
  report: T.object,
  groupAppsBy: T.string,
  unselectedStateText: T.string,
  onSearchChange: T.func,
  onChange: T.func,
};

export default CrossAppPairingsDropdown;
